import { DataBean } from "../DataBean";

export class QualityInspectionProduct extends DataBean {

  public async getQualityInspectionProductCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityInspectionProductCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityInspectionProductRender( page: number, rows: number, properties: any, fromDate: any, uptoDate: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityInspectionProductRender_Number_Number_java.util.Map_java.util.Date_java.util.Date",
      [page, rows, properties, fromDate, uptoDate]
    );
  }

  public async deleteQualityInspectionProduct(idqualityinspectionproduct: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityInspectionProduct_Number", [idqualityinspectionproduct]);
  }

  public async updateQualityInspectionProduct(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityInspectionProduct_updateQualityInspectionProduct_com.orange.finance.processcontract.bean.QualityInspectionProduct",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityInspectionProduct",
        },
      ]
    );
  }
}
